import api from './api.js';

export const facilityAgentRolesAPI = {
  // Get all roles for the facility agent
  getRoles: (params = {}) => api.get('/api/facility-agent-roles', { params }),
  
  // Get role statistics
  getRoleStats: () => api.get('/api/facility-agent-roles/stats'),
  
  // Get available permissions
  getAvailablePermissions: () => api.get('/api/facility-agent-roles/permissions'),
  
  // Get single role
  getRole: (roleId) => api.get(`/api/facility-agent-roles/${roleId}`),
  
  // Create new role
  createRole: (roleData) => api.post('/api/facility-agent-roles', roleData),
  
  // Update role
  updateRole: (roleId, roleData) => api.put(`/api/facility-agent-roles/${roleId}`, roleData),
  
  // Delete role
  deleteRole: (roleId) => api.delete(`/api/facility-agent-roles/${roleId}`),
  
  // Assign role to sub-account
  assignRoleToSubAccount: (roleId, subAccountId) => api.post('/api/facility-agent-roles/assign', { roleId, subAccountId }),
  
  // Remove role from sub-account
  removeRoleFromSubAccount: (subAccountId) => api.delete(`/api/facility-agent-roles/assign/${subAccountId}`),
  
  // Get pending role approval requests
  getPendingRoleApprovals: () => api.get('/api/facility-agent-roles/approval-requests/pending'),
  
  // Get role approval history
  getRoleApprovalHistory: (params = {}) => api.get('/api/facility-agent-roles/approval-requests/history', { params })
}; 